import {Directive} from '@angular/core';
import {BaseListComponent} from '../../abstract/base-list.component';
import {ErrorConstants} from '../../shared/constants/error-constants';

@Directive()
export abstract class GetBankAccountListAction  extends BaseListComponent {
  protected getList(url) {

    this.loadFlag = true;
    this.dataManager.getRequest(url, 0).subscribe(
      (res) => {
        this.loadFlag = false;
        this.getListRes(res);
        this.setPagination(res);
        if (res.data.length === 0) {
          this.errorMsg = ErrorConstants.bankAccountsErrorMsg[0];
        } else {
          this.errorMsg = null;
        }
      },
      (err) => {
        this.loadFlag = false;
        this.getListErr(err);
      }
    );
  }
}
